var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Signup"},[_c('SignupContainer',{attrs:{"preset-email":_vm.email,"token":_vm.token,"redirect-to":_vm.redirectTo,"tlsc":_vm.tlsc,"forwarded-params":_vm.forwardedParams,"forwarded-queries":_vm.forwardedQueries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }